import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EntryItem from './entryItem';

class EntriesList extends Component {

  componentWillMount() {
    this.props.actions.loadCurrentUserStream(this.props.currentUser);
  }

  render() {
    if (this.props.homeStreamLoaded) {
      const listItems = this.props.homeStream.map(entry => {
        const entryCommentStatus = this.props.entriesCommentStatusById[entry.id] || null;
        const entryLikeStatus = this.props.entriesLikeStatusById[entry.id] || null;
        return <EntryItem 
                  key={entry.id} 
                  currentUser={this.props.currentUser} 
                  likeTypes={this.props.likeTypes}
                  entry={entry} 
                  onCreateComment={this.props.actions.createComment} 
                  onCreateLike={this.props.actions.createLike} 
                  onDestroyLike={this.props.actions.destroyLike} 
                  entryCommentStatus={entryCommentStatus}
                  entryLikeStatus={entryLikeStatus} />;
      });

      return (
        <div>
          {this.props.showLoadPreviousEntries && <button onClick={this.props.actions.loadStreamPrevious}>Load Previous Entries</button>}
          <ol>
            {listItems}
          </ol>
          {this.props.showLoadNextEntries && <button onClick={this.props.actions.loadStreamNext}>Load Next Entries</button>}
        </div>
      );
    } else if (this.props.homeStreamLoadingError) {
      return (
        <p>Couldn't load stream ({this.props.homeStreamLoadingError})</p>
      );
    } else {
      return (
        <div>Loading entries...</div>
      );
    }
  }
}

EntriesList.propTypes = {
  actions: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  homeStream: PropTypes.array,
  homeStreamLoading: PropTypes.bool.isRequired,
  homeStreamLoaded: PropTypes.bool.isRequired,
  homeStreamLoadingError: PropTypes.string,
  entriesCommentStatusById: PropTypes.object.isRequired,
  entriesLikeStatusById: PropTypes.object.isRequired,
  showLoadPreviousEntries: PropTypes.bool.isRequired,
  showLoadNextEntries: PropTypes.bool.isRequired,
  likeTypes: PropTypes.array.isRequired
};

export default EntriesList;


// WEBPACK FOOTER //
// ./src/views/entriesList.js